import React from 'react';
import ReactPaginate from 'react-paginate';
import { useHistory, useLocation } from 'react-router-dom';

const Pagination = ({ currentPage, totalPages, onPageChange, category }) => {
  const history = useHistory();
  const location = useLocation();

  const handlePageClick = (data) => {
    const newPage = data.selected + 1;
    onPageChange(newPage);

    // Update URL with new page number while preserving other parameters
    const params = new URLSearchParams(location.search);
    params.set('page', newPage.toString());
    params.set('category', category);

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  return (
    <ReactPaginate
      previousLabel={''}
      nextLabel={''}
      breakLabel={'...'}
      pageCount={totalPages}
      forcePage={currentPage - 1}
      onPageChange={handlePageClick}
      containerClassName={'pagination'}
      activeClassName={'active'}
    />
  );
};

export default Pagination;
